<template>
  <v-text-field
    v-model="internalValue"
    v-bind="$attrs"
    v-on="$listeners"
    :color="color || primaryColor"
    :rules="combinedRules"
    :clearable="clearable"
  >
    <slot />
  </v-text-field>
</template>

<script>
export default {
  name: 'AmountInput',
  props: {
    value: {
      type: [Number, String],
      default: ''
    },
    rules: {
      type: Array,
      default: () => []
    },
    isRequired: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: null
    },
    clearable: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    defaultRules () {
      const rules = []

      if (this.isRequired) {
        rules.push(v => !!v || this.$t('errors.common.required'))
      }
      rules.push(
        v => {
          if (!v) return true

          const locale = this.$store.getters['profileStore/profileData'].preferredLocale
          const pattern = locale === 'de-DE' ? /^\d*(,\d{1,2})?$/ : /^\d*(\.\d{1,2})?$/
          return pattern.test(v) || this.$t('errors.common.invalidFormat')
        }
      )
      return rules
    },
    combinedRules () {
      return [
        ...this.defaultRules,
        ...this.rules
      ]
    },
    internalValue: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>
